import { ProductSlug } from 'common/billing/constants/ProductSlug'
import { ProductSlugToTypeMap } from 'common/billing/entities/pro/utils/ProductSlugToTypeMap'
import { ProductType } from 'common/core/interfaces/products'

const AI_INCLUDED_TYPES: ProductType[] = [
  ProductType.PRO,
  ProductType.BUSINESS,
  ProductType.ADVANCED,
]

export const getIsAiIncludedInPlan = (slug: ProductSlug | undefined) => {
  if (!slug) {
    return false
  }
  const productType = ProductSlugToTypeMap[slug]
  return AI_INCLUDED_TYPES.includes(productType)
}
